import React, { Component } from "react";

const logo = require('../assets/transparentLogo.png')

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Error caught by ErrorBoundary:", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className={'mx-auto mt-20 bg-dutch_white-200 p-10 flex flex-col w-[70%] border-dutch_white-100 border-4 rounded shadow'}>
                    <img className={'h-[200px] w-[200px] mx-auto'}
                         src={String(logo)}
                         alt={'Brainmeter'}
                    />
                    <h1 className={'text-columbia_blue-900 font-bold text-4xl'}>Something went wrong, we're so sorry for the
                        disruption! Please try again later.</h1>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;